import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { mortgageContactSubmit } from '../../../../../../reducers/mortgage';
import { float, numberWithCommas, formatPhoneNumber } from '../../../../../helpers';
import { calculateMortgageCost, calculateMortgagePayment } from '../../../../../helpers/mortgage';
import { trackingEvent } from '../../../../../helpers/tracking';
import RenderInput from '../../../../../common/components/render-input';
import SubmitButton, { onSubmit } from '../../../../../common/components/submit-button';
import LoadingState from '../../../../../common/components/loading';
import { formName as StepOneFormName } from '../step-one';
import { formName as StepTwoFormName } from '../step-two';
import { formName as StepThreeFormName } from '../step-three';
import { formName as StepFourFormName } from '../step-four';
import { formName as StepFiveFormName } from '../step-five';

export const formName = Routes.CONTACT;

const tracking = {
    eventAction: 'Mortgage Calculator - Form Submission',
    eventLabel: 'Start now'
};

const validate = values => v(values, {
    firstName: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        format: {
            pattern: /[A-Z.\-\s]+/i,
            message: 'can only contain letter, periods or hyphens'
        }
    },
    lastName: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        format: {
            pattern: /[A-Z.\-\s]+/i,
            message: 'can only contain letter, periods or hyphens'
        }
    },
    email: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        email: {
            message: 'needs to be a valid email'
        }
    },
    phone: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        format: {
            pattern: /[0-9()\-\s]+/i,
            message: 'can only contain numbers, brackets and hyphens'
        },
        length: {
            is: 14,
            wrongLength: 'must be 10 digits'
        }
    }
});

class ContactForm extends Component {
    render() {
        const {
            props: {
                formLoading,
                formError
            }
        } = this;

        const loading = formLoading && !formError;

        return (
            <form method='post' className={styles.form}>
                {
                    loading &&
                    <LoadingState title='Submitting Form'/>
                }
                {
                    !loading &&
                    <div>
                        <Field
                            name='firstName'
                            label='First Name'
                            autoComplete='given-name'
                            component={RenderInput}
                        />
                        <Field
                            name='lastName'
                            label='Last Name'
                            autoComplete='family-name'
                            component={RenderInput}
                        />
                        <Field
                            type='email'
                            name='email'
                            label='Email Address'
                            autoComplete='email'
                            component={RenderInput}
                        />
                        <Field
                            type='tel'
                            name='phone'
                            label='Phone Number'
                            autoComplete='tel-national'
                            format={formatPhoneNumber}
                            component={RenderInput}
                        />
                        <SubmitButton form={formName} className={styles.button}>Start now</SubmitButton>
                    </div>
                }
                {
                    formError &&
                    <p className={styles.errorMessage}>There seems to be an error with the form. Please try again later.</p>
                }
            </form>
        );
    }
}

ContactForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    redirectPath: `/mortgage${Routes.THANKYOU}`,
    dispatchFunction: mortgageContactSubmit,
    tracking: () => trackingEvent(tracking)
})(ContactForm);

const StepOneForm = formValueSelector(StepOneFormName);
const StepTwoForm = formValueSelector(StepTwoFormName);
const StepThreeForm = formValueSelector(StepThreeFormName);
const StepFourForm = formValueSelector(StepFourFormName);
const StepFiveForm = formValueSelector(StepFiveFormName);

export default withRouter(
    connect(( state ) => ({
        formLoading: state.mortgage.isLoading,
        formError: state.mortgage.hasError,
        token: state.auth.token,
        formValues: {
            askingPrice: StepOneForm(state, 'askingPrice') ? `$${numberWithCommas(float(StepOneForm(state, 'askingPrice')))}` : '$0',
            downPayment: StepTwoForm(state, 'downPayment') ? `${float(StepTwoForm(state, 'downPayment')) * 100}%` : '0%',
            amortizationPeriod: StepThreeForm(state, 'amortizationPeriod') ? StepThreeForm(state, 'amortizationPeriod') : '0',
            paymentFrequency: StepFourForm(state, 'paymentFrequency') ? StepFourForm(state, 'paymentFrequency') : '',
            mortgageTerm: StepFiveForm(state, 'mortgageTerm') ? StepFiveForm(state, 'mortgageTerm') : '',
            mortgageRate: StepFiveForm(state, 'mortgageRate') ? `${float(StepFiveForm(state, 'mortgageRate'))}%` : '0%',
            mortgageCost: StepOneForm(state, 'askingPrice') && StepTwoForm(state, 'downPayment') ? `$${numberWithCommas((calculateMortgageCost(StepOneForm(state, 'askingPrice'), StepTwoForm(state, 'downPayment'))))}` : '$0',
            mortgagePayment: StepOneForm(state, 'askingPrice') && StepTwoForm(state, 'downPayment') && StepThreeForm(state, 'amortizationPeriod') && StepFourForm(state, 'paymentFrequencyNum') && StepFiveForm(state, 'mortgageRate') ? `$${numberWithCommas((calculateMortgagePayment(StepOneForm(state, 'askingPrice'), StepTwoForm(state, 'downPayment'), StepThreeForm(state, 'amortizationPeriod'), StepFourForm(state, 'paymentFrequencyNum'), StepFiveForm(state, 'mortgageRate'), StepFourForm(state, 'paymentFrequency'))))}` : '$0',
        }
    })
)(ContactForm));
